module.exports = __webpack_public_path__ + "img/mile3m.afdff1b2.webp";